import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)   // pass the i18n instance to react-i18next.
    .init({
        fallbackLng: 'en',
        resources: {
            en: {
                common: require('./locales/en/common.json'),
                contact: require('./locales/en/contact.json'),
                document: require('./locales/en/document.json'),
                history: require('./locales/en/history.json'),
                product: require('./locales/en/product.json'),
                settings: require('./locales/en/settings.json'),
                signedOut: require('./locales/en/signedOut.json'),
            },
            es: {
                common: require('./locales/es/common.json'),
                contact: require('./locales/es/contact.json'),
                document: require('./locales/es/document.json'),
                history: require('./locales/es/history.json'),
                product: require('./locales/es/product.json'),
                settings: require('./locales/es/settings.json'),
                signedOut: require('./locales/es/signedOut.json'),
            },
            pt: {
                common: require('./locales/pt/common.json'),
                contact: require('./locales/pt/contact.json'),
                document: require('./locales/pt/document.json'),
                history: require('./locales/pt/history.json'),
                product: require('./locales/pt/product.json'),
                settings: require('./locales/pt/settings.json'),
                signedOut: require('./locales/pt/signedOut.json'),
            }
        },

        ns: ['common', 'contact', 'document', 'history', 'product', 'settings', 'signedOut'],
        defaultNS: 'common',

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        detection: {
            order: ['localStorage', 'header', 'querystring', 'navigator', 'htmlTag'],
            lookupCookie: 'rapidtoolz_language',

        }
    })

export default i18n